export default [
  'BOLID2_SECTION',
  'BOLID2_SECTION_GROUP',
  'BOLID2_ACCESS_POINT',
  'BOLID2_ACCESS_ZONE',
  'BOLID2_DEVICE',
  'BOLID2_READER',
  'BOLID2_RELAY',
  'BOLID2_LOOP',
  'BOLID2_SCRIPT'
]


// WEBPACK FOOTER //
// ./src/consts/mapObjTypes.js